import type { GradeElementaryMiddle, GradeHigh, Revision, SchoolType } from './schemas'

/***************** 학교급 *****************/
export const SCHOOL_TYPE_KO_FULL = {
  ELEMENTARY: '초등학교',
  MIDDLE: '중학교',
  HIGH: '고등학교',
} as const satisfies Record<SchoolType, string>
export type SchoolTypeKoFull = (typeof SCHOOL_TYPE_KO_FULL)[SchoolType]

export const SCHOOL_TYPE_KO_ABBR = {
  ELEMENTARY: '초',
  MIDDLE: '중',
  HIGH: '고',
} as const satisfies Record<SchoolType, string>
export type SchoolTypeKoAbbr = (typeof SCHOOL_TYPE_KO_ABBR)[SchoolType]

/***************** 학교 학년 약어 *****************/
export type GradeElementaryMiddleAbbr = `${SchoolTypeKoAbbr}${GradeElementaryMiddle}`

/***************** 학년 *****************/
// 화면 폭이 좁은 곳에서 쓰는 고등 과목 축약 표기
export const SUBJECT_HIGH_SHORT = {
  '고등수학(상)': '수학(상)',
  '고등수학(하)': '수학(하)',
  '수학 I': '수학 I',
  '수학 II': '수학 II',
  미적분: '미적분',
  기하: '기하',
  공통수학1: '공통수학1',
  공통수학2: '공통수학2',
  대수: '대수',
  미적분1: '미적분1',
  '확률과 통계': '확통',
  미적분2: '미적분2',
  '(구) 교육과정': '(구) 교육과정',
  '교육과정 외': '교육과정 외',
} as const satisfies Record<GradeHigh, string>

/***************** 개정 *****************/
export const REVISION_KO = {
  CURRICULUM_09: '09개정',
  CURRICULUM_15: '15개정',
  CURRICULUM_22: '22개정',
} as const satisfies Record<Revision, string>

export const REVISIONS = [
  { label: REVISION_KO.CURRICULUM_15, value: 'CURRICULUM_15' },
  { label: REVISION_KO.CURRICULUM_22, value: 'CURRICULUM_22' },
] as const satisfies readonly { label: string; value: Revision }[]
